var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { isRtl } from './utils';
/**
 * @hidden
 */
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        var columnResize = this.props.columnResize;
        if (columnResize && columnResize.resizable) {
            columnResize.setIsRtl(isRtl(this.element));
        }
    };
    Header.prototype.render = function () {
        var _this = this;
        return (React.createElement("thead", { className: "k-grid-header", ref: function (el) { return _this.element = el; } },
            this.props.headerRow,
            this.props.filterRow));
    };
    return Header;
}(React.Component));
export { Header };
//# sourceMappingURL=Header.js.map